import { splashLogo } from '@/assets/images';

import { Image } from '@/components/ui';
import { useScaling } from '@/hooks';

export const Logo = () => {
  const { scale } = useScaling();
  return <Image source={splashLogo} width={scale(120)} height={scale(110)} resizeMode="cover" />;
};
